/**
 * Panel de comentarios: abrir, elegir motivo y enviar.
 *
 * Mismo gesto que el carrito pero desde la izquierda. Se cierra con Escape,
 * tocando fuera o con la ×, y al cerrar el foco vuelve a la pestaña — si no,
 * quien navega con teclado se queda perdido al final del documento. En móvil el
 * panel es una hoja inferior y el disparador es una pastilla sobre la barra.
 *
 * El envío va a un formulario de Google. Google no manda cabeceras CORS, así
 * que la petición se hace en modo no-cors: llega y se guarda, pero el navegador
 * no deja leer la respuesta. Por eso el acuse se muestra en cuanto se manda, sin
 * esperar confirmación. Es la única forma de recibir respuestas anónimas sin
 * montar un servidor, y para un buzón de comentarios el intercambio vale.
 */
(function () {
  var panel = document.querySelector("[data-ma-fb]");
  // Dos disparadores: la pestaña lateral en escritorio y la pastilla en móvil.
  // Cada uno se ve en su tamaño, pero ambos abren el mismo panel.
  var disparadores = document.querySelectorAll("[data-ma-fb-open]");
  if (!panel || !disparadores.length) return;
  var ultimo = disparadores[0];

  var pasos = {
    motivo: panel.querySelector('[data-ma-fb-paso="motivo"]'),
    detalle: panel.querySelector('[data-ma-fb-paso="detalle"]'),
    gracias: panel.querySelector('[data-ma-fb-paso="gracias"]'),
  };
  var elegido = panel.querySelector("[data-ma-fb-elegido]");
  var comentario = panel.querySelector("#ma-fb-comentario");
  var correo = panel.querySelector("#ma-fb-correo");
  var botonEnviar = panel.querySelector("[data-ma-fb-enviar]");
  var motivoActual = "";

  function verPaso(nombre) {
    Object.keys(pasos).forEach(function (k) {
      if (!pasos[k]) return;
      if (k === nombre) pasos[k].removeAttribute("hidden");
      else pasos[k].setAttribute("hidden", "");
    });
  }

  function abrir() {
    panel.removeAttribute("hidden");
    // Un cuadro para que el navegador aplique el estado inicial y la
    // transición se vea; sin esto el panel aparece de golpe.
    requestAnimationFrame(function () {
      panel.classList.add("is-open");
    });
    marcarAbierto("true");
    document.documentElement.style.overflow = "hidden";
    var cerrarBtn = panel.querySelector(".ma-fb__cerrar");
    if (cerrarBtn) cerrarBtn.focus();
  }

  function cerrar() {
    var yaEnviado = pasos.gracias && !pasos.gracias.hasAttribute("hidden");
    panel.classList.remove("is-open");
    marcarAbierto("false");
    document.documentElement.style.overflow = "";
    // Esperar a que termine el deslizamiento antes de ocultarlo del todo.
    setTimeout(function () {
      panel.setAttribute("hidden", "");
      // Si ya se envió, dejarlo en blanco para la próxima vez.
      if (yaEnviado) reiniciar();
    }, 260);
    // El foco vuelve al disparador que se usó; si no, quien navega con teclado
    // se queda perdido al final del documento.
    ultimo.focus();
  }

  function marcarAbierto(valor) {
    Array.prototype.forEach.call(disparadores, function (d) {
      d.setAttribute("aria-expanded", valor);
    });
  }

  function reiniciar() {
    motivoActual = "";
    if (comentario) comentario.value = "";
    if (botonEnviar) botonEnviar.disabled = false;
    verPaso("motivo");
  }

  /**
   * Google sólo guarda respuestas en /formResponse. Se acepta tanto el enlace
   * para compartir como el de edición para no depender de cuál se pegó.
   */
  function urlDeEnvio(bruta) {
    var limpia = bruta.split("?")[0].replace(/\/(viewform|edit)$/, "/formResponse");
    if (!/\/formResponse$/.test(limpia)) {
      limpia = limpia.replace(/\/+$/, "") + "/formResponse";
    }
    return limpia;
  }

  function enviar() {
    var destino = panel.getAttribute("data-endpoint") || "";
    if (!destino || !motivoActual) return;

    var datos = new FormData();
    function poner(attr, valor) {
      var campo = panel.getAttribute(attr);
      if (campo && valor) datos.append(campo, valor);
    }
    poner("data-campo-motivo", motivoActual);
    poner("data-campo-comentario", comentario ? comentario.value.trim() : "");
    poner("data-campo-correo", correo ? correo.value.trim() : "");
    // La página de origen es lo más útil de todo el formulario: sin ella,
    // "algo no funciona" no se puede investigar.
    poner("data-campo-pagina", window.location.pathname + " · " + window.innerWidth + "px");

    if (botonEnviar) botonEnviar.disabled = true;
    fetch(urlDeEnvio(destino), { method: "POST", mode: "no-cors", body: datos }).catch(
      function () {
        // Sin respuesta legible no hay nada que reintentar; el acuse ya se dio.
      }
    );
    verPaso("gracias");
  }

  Array.prototype.forEach.call(disparadores, function (d) {
    d.addEventListener("click", function () {
      ultimo = d;
      abrir();
    });
  });

  panel.addEventListener("click", function (e) {
    if (e.target.closest("[data-ma-fb-close]")) {
      cerrar();
      return;
    }
    var motivo = e.target.closest("[data-ma-fb-motivo]");
    if (motivo) {
      motivoActual = motivo.getAttribute("data-ma-fb-motivo");
      if (elegido) elegido.textContent = motivoActual;
      verPaso("detalle");
      if (comentario) comentario.focus();
      return;
    }
    if (e.target.closest("[data-ma-fb-volver]")) {
      verPaso("motivo");
      return;
    }
    if (e.target.closest("[data-ma-fb-enviar]")) enviar();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !panel.hasAttribute("hidden")) cerrar();
  });

  // La pastilla de móvil se aparta al BAJAR y vuelve al SUBIR (2-nov-2026):
  // aun como ícono quedaba encima de títulos y precios de las tarjetas. Es
  // el mismo gesto de las barras del navegador; arriba de todo siempre se ve.
  var fab = document.querySelector(".ma-fb-fab");
  if (fab) {
    var antes = window.scrollY;
    window.addEventListener("scroll", function () {
      var y = window.scrollY;
      if (Math.abs(y - antes) < 8) return;
      fab.classList.toggle("is-oculta", y > antes && y > 200);
      antes = y;
    }, { passive: true });
  }
})();
